module.exports = __webpack_public_path__ + "static/img/SourceSansPro-It.4cff969.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scss/font/sourcesans/SourceSansPro-It.svg
// module id = 694
// module chunks = 3